// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"a71c94f4","318":"d31cce3a","377":"d85226e8","640":"1ed4f9b3","700":"87e7a834"}[chunkId] + ".chunk.css";
};